<template>
  <div class="text-center my-5">
    <feather-icon
      icon="CheckIcon"
      size="130"
      class="text-success mb-3"
    />
    <div class="font-medium-4">
      {{ $t('settings.profile.reservation.success') }}
    </div>
    <b-button
      size="lg"
      variant="primary"
      class="mt-3"
      @click="$emit('back')"
    >
      {{ $t('settings.profile.reservation.btn-back') }}
    </b-button>
  </div>
</template>

<script>
export default {
  name: 'ReservationSuccess',
}
</script>
